/**
 * The furniture every event-details page shares. The event itself (title, body, venue)
 * comes from `data/events`, keyed by slug.
 *
 * `mapSrc` and `locationsTitle` were here and were removed on 2026-09-03. The embed was the
 * template's, centred on **Block G, Dhaka**, under a heading that read "See Our Locations"
 * — on three pages that are indexed and in the sitemap. None of the three events has a
 * fixed venue yet; the one that names a city says "venue to be announced", and the venue
 * each event does state is already printed in the meta row above the body.
 *
 * A map is a claim about where to go. Put one back when a venue is fixed, centred on that
 * venue, not on a city.
 */
export const EVENT_DETAIL = {
  contactTitle: 'Contact us',
} as const
